import React from "react";
import DateHelper from "../DateHelper/DateHelper";

class RatesDashboardHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var header_dates = [];
    var idx = 0;

    for (
      var d = new Date(this.props.start_date);
      d <= new Date(this.props.end_date);
      d.setDate(d.getDate() + 1)
    ) {
      var date_data =
        this.props.dailyRoomTypes[
          DateHelper.printDateToScreen(d, "yyyy-MM-dd")
        ];
      var heat_map_color = this.getHeatMapColor(
        date_data[0].rooms_available_at_property,
        date_data[0].rooms_available_last_year_at_property,
        date_data[0].total_rooms_at_property
      );

      var style = {
        backgroundColor: heat_map_color,
        color: this.lightOrDark(heat_map_color) == "dark" ? "#DFDFDF" : "#222",
      };

      header_dates.push(
        <div
          className="HeaderDateCell"
          style={{
            left:
              idx * (this.props.dateView == "month" ? 70 : 160) + 160 + "px",
          }}
          key={d}
        >
          {this.renderDate(d)}
          {date_data ? (
            <span
              className="occupancy badge"
              style={style}
              title={I18n.t("overall_property_occupancy")}
            >
              {(
                (date_data[0].total_rooms_booked_at_property /
                  date_data[0].total_rooms_at_property) *
                100
              ).toFixed(0)}
              %
            </span>
          ) : null}
        </div>
      );
      idx = idx + 1;
    }

    header_dates.unshift(
      <div className="HeaderDateCell" style={{ left: 0 }} key="blank">
        &nbsp;
      </div>
    );

    return <div className="RatesDashboardHeader">{header_dates}</div>;
  }

  renderDate(d) {
    if (this.props.dateView == "month") {
      var weekday = DateHelper.printDateToScreen(d, "ccc");
      var weekdate = DateHelper.printDateToScreen(d, "D");
      return (
        <span style={{ lineHeight: "15px", marginBottom: "3px" }}>
          {weekday}
          <br />
          {weekdate}
        </span>
      );
    } else {
      return <span>{DateHelper.printDateToScreen(d, "ccc D")}</span>;
    }
  }

  lightOrDark(color) {
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );

      var r = color[1];
      var g = color[2];
      var b = color[3];
    } else {
      // If RGB --> Convert it to HEX: http://gist.github.com/983661
      color = +(
        "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
      );

      var r = color >> 16;
      var g = (color >> 8) & 255;
      var b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return "light";
    } else {
      return "dark";
    }
  }

  getHeatMapColor(
    rooms_available_this_year,
    rooms_available_last_year,
    total_rooms
  ) {
    if (!this.props.heatMapColors) {
      return;
    }

    var diff = rooms_available_last_year - rooms_available_this_year;
    if (diff < 0) {
      // we're behind - use last 3 colors
      var percent = Math.round(Math.abs(diff / total_rooms) * 100);
      if (percent <= 33) {
        return this.props.heatMapColors[4];
      } else if (percent > 33 && percent <= 67) {
        return this.props.heatMapColors[5];
      } else {
        return this.props.heatMapColors[6];
      }
    } else if (diff > 0) {
      // we're ahead - use first 3 colors
      var percent = Math.round(Math.abs(diff / total_rooms) * 100);
      if (percent <= 33) {
        return this.props.heatMapColors[2];
      } else if (percent > 33 && percent <= 67) {
        return this.props.heatMapColors[1];
      } else {
        return this.props.heatMapColors[0];
      }
    } else {
      // we're the same - use middle color
      return this.props.heatMapColors[3];
    }
  }
}

export default RatesDashboardHeader;
